/* src/app/shared/dialog/tv-file-upload-popup/tv-file-upload-popup.component.scss */
::ng-deep .file-upload-container,
.button-margin-auto {
  margin: 14px auto 0;
}
.margin-top-14 {
  margin-top: 14px;
}
.margin-right-14 {
  margin-right: 14px;
}
/*# sourceMappingURL=tv-file-upload-popup.component.css.map */
